import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';

import { map, mergeMap } from 'rxjs/operators';
import { Actions } from '../../actions';
import {
  CreateAssetSuccess,
  ReplaceAssetSuccess,
  UpdateAssetUpload,
} from '../action-creators';
import { CREATE_ASSET_SUCCESS, REPLACE_ASSET_SUCCESS } from '../actions';

export const uploadProgressEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, CreateAssetSuccess | ReplaceAssetSuccess>(
      CREATE_ASSET_SUCCESS,
      REPLACE_ASSET_SUCCESS
    ),
    mergeMap((action) => {
      return action.response.upload.progress.pipe(
        map((p) => new UpdateAssetUpload(action.response.id, 'progress', p))
      );
    })
  );
